export default __webpack_public_path__ + "78ed51ef4fe1451188b08f5d53e743de.png";